import React, { useEffect, useState } from "react";
import { TbMessageCircle2  } from "react-icons/tb";
// import { GoogleMap, useJsApiLoader, Marker, InfoWindow } from '@react-google-maps/api'
import { motion } from "framer-motion"
import Nav from "../main/Nav";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import useEmailSender from '../main/contact/useEmailSender'
import bgImage from "../images/main/main4.jpg";



const Cnct = () => {
    const [name, setName] = useState('');
    const [contact, setContact] = useState('');
    const [projectDetails, setProjectDetails] = useState('');
    const { sendEmail, isSending } = useEmailSender();


    const sendBtn = async () => {
        const result = await sendEmail(name, contact, projectDetails);
        
        if (result.success) {
            // 성공 시 입력 필드 초기화
            setName('');
            setContact('');
            setProjectDetails('');
        }
    };
    
    
    const showSwal =  (msg, gubun) => {
        return withReactContent(Swal).fire({
          title: msg,
          confirmButtonText : "확인",
          confirmButtonColor :'#f97316',
          icon: gubun,
          focusConfirm: false,
        });
    }

    return (
        <div className=" h-screen">
        <Nav></Nav>


        <div 
          className="h-full bg-no-repeat bg-cover bg-left-bottom"
          style={{ backgroundImage: `url(${bgImage})` }}
        >
          <div className="lg:pt-[180px]  pt-20">
               <div className="lg:flex justify-center items-center h-full   ">
        
              <div className="w-full lg:w-[1400px] z-10  ">
                <motion.div 
                 initial={{ opacity: 0, y: -30 }}
                 viewport={{ once: false }}
                 whileInView={{ opacity: 1, y: 0, transition: { delay: 0.2 } }}
                className="text-3xl text-center lg:text-start lg:text-6xl font-bold text-zinc-500 font-[Pretendard-Regular] pb-6">
                  <span># Contact Us</span>
                </motion.div> 
                <div className="flex w-full items-center jusitfy-center lg:justify-between">
    
                  <div className="w-full lg:w-1/2 space-y-3 ">
                    
                    <div className="w-full pt-2 flex justify-center w-[90%] border-e border-gray-100/20">
                      <div className="w-full text-center lg:text-start">
                        <div className="space-y-3 text-lg">
                          <div><span className="text-white text-zinc-300">프로젝트 문의</span></div>
                          <div><input type="text" placeholder="성함을 입력해주세요."
                            value={name}
                            onChange={(e) => setName(e.target.value)}  
                            className="border rounded w-[80%] h-[40px] px-2 
                                      placeholder:text-lg
                                      focus:outline-orange-400" ></input></div>

                      <div><input type="text"  placeholder="연락처를 입력해주세요." 
                            value={contact}
                            onChange={(e) => setContact(e.target.value)} 
                            className="border rounded w-[80%] h-[40px] px-2
                                      placeholder:text-lg
                                      focus:outline-orange-400"></input></div>

                      <div><textarea placeholder="어떤 프로젝트인지 간단하게 입력해주세요."
                            value={projectDetails}  
                            onChange={(e) => setProjectDetails(e.target.value)} 
                            className="border rounded w-[80%] h-[200px] px-2
                                      placeholder:text-lg
                                      focus:outline-orange-400
                                    " ></textarea></div>
                    </div>
                        <button 
                            type="button" 
                            disabled={isSending}
                            className={`px-4 py-1 text-xl text-white rounded-lg w-[80%] transition-colors duration-300 
                                      ${isSending 
                                        ? 'bg-gray-500 cursor-not-allowed' 
                                        : 'bg-zinc-400 hover:bg-orange-400 hover:transition-y hover:duration-300 hover:ease-in'}`}
                            onClick={sendBtn}
                        >
                            <div className="ps-[60px] hidden"><TbMessageCircle2 size="" className="text-orange-500 w-[200px] "/></div>    
                            <div className="text-xl text-center">
                                {isSending ? '메일 전송 중...' : '프로젝트 문의'}
                            </div>
                            <div className="text-base text-center text-gray-400 mt-4 hidden">서비스 이용 및 프로젝트 문의 내용을 <br/> 남겨주시면 연락드리겠습니다.</div>
                        </button>
                      </div>
                    </div>
                  </div>
    
                  <div className="hidden lg:block w-1/2 space-y-3 text-lg">
                    <div><span className="text-white text-zinc-300">회사 위치</span></div>
                    <div className="relative">
                      <iframe
                        src="https://maps.google.com/maps?q=37.568708,126.826708+(솔컴바인+보타닉비즈타워)&hl=ko&z=17&output=embed"
                        width="100%"
                        height="360"
                        className="rounded-xl"
                        style={{ border: 0 }}
                        allowFullScreen=""
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                        title="보타닉비즈타워 위치"
                      />
                      
                      {/* 지도 위 정보 오버레이 */}
                      <div className="absolute bottom-4 left-4 right-4 bg-white/95 backdrop-blur-sm rounded-lg p-3 shadow-lg">
                        <div className="flex items-center gap-2 mb-2">
                          <div className="w-3 h-3 bg-red-500 rounded-full animate-pulse"></div>
                          <h4 className="font-bold text-gray-800 text-sm">📍 솔컴바인</h4>
                        </div>
                        <div className="flex justify-between items-center text-sm">
                          <div className="text-gray-700">
                            <div>서울시 강서구 마곡중앙5로1길 20</div>
                            <div>보타닉비즈타워 519호</div>
                          </div>
                          <div className="text-right text-gray-600">
                            <div>📞 1800-8477</div>
                            <a 
                              href="https://maps.google.com/maps?q=37.568708,126.826708"
                              target="_blank"
                              rel="noreferrer"
                              className="text-orange-500 hover:text-orange-600 text-xs underline"
                            >
                              길찾기
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
    
                </div>
    
                <div className="border-b border-gray-100/20 w-full h-[20px] my-[20px] "></div>
              
                <div className="">
                <div className="hidden lg:grid lg:grid-cols-2 lg:gap-x-48 text-zinc-400 text-xs lg:text-base">
                    <div className="flex">
                    <div>
                        <span>공동대표자 : </span>
                    </div>
                    <div className="text-left text-xs lg:text-base text-zinc-300 pl-2 ">
                        <span>심재문 최진형</span>
                    </div>
                    </div>
                    <div className="flex">
                        <div className="">
                            <span>이메일 : </span>
                        </div>
                        <div className="text-left text-xs lg:text-base text-zinc-300 pl-2 ">
                            <span>sckcs@solcombine.com</span>
                        </div>
                    </div>

                    <div className="flex">
                    <div className="  lg:flex text-xs lg:text-base">
                        <span>전화 : </span>
                    </div>
                    <div className="text-left text-xs lg:text-base text-zinc-300 pl-2  ">
                        <span>1800-8477</span>
                    </div>
                    </div>

                    <div className="flex">
                    <div className="pr-2">
                        <span>통신판매번호 : </span>
                    </div>
                    <div className="text-left text-xs lg:text-base text-zinc-300 lg:pl-2">
                        <span>제 2023-서울강동-2648 호</span>
                    </div>
                    </div>
                    <div className="flex">
                    <div className="lg:flex text-xs lg:text-base">
                        <span>사업자 등록번호 : </span>
                    </div>
                    <div className="text-left text-xs lg:text-base text-zinc-300 lg:pl-2">
                        <span>801-86-02860 (주식회사 솔컴바인)</span>
                    </div>
                    </div>
                    <div className="flex">
                    <div className="lg:flex text-xs lg:text-base">
                        <span>주소 : </span>
                    </div>
                    <div className="text-left text-xs lg:text-base text-zinc-300 lg:pl-2">
                        <span>서울시 강서구 마곡중앙5로1길 20 보타닉비즈타워 519호</span>
                    </div>
                    </div>

                </div>
                <div className="flex mt-2 hidden">
                    <div className=" text-zinc-400 text-xs lg:text-base">
                        <span>주소 : </span>
                    </div>
                    <div className="text-left text-xs lg:text-base text-zinc-300 pl-2">
                        <span>
                        서울시 강서구 마곡중앙5로1길 20 보타닉비즈타워 519호
                        </span>
                    </div>

                    
                </div>
                <div className="text-center lg:pe-[10%] pt-[3%] text-xs lg:text-sm pt-5 text-zinc-400">
                <span>Copyright (c)2023 SOLCOMBINE. All Rights Reserved.</span>
                </div>
            </div>
          
          </div> 
    
    
            </div>
    
          </div>
    
         
        </div>
        </div>
      );
};

export default Cnct;